export default __webpack_public_path__ + "static/media/mailbox.5bd833da.svg";